export class HardTimeoutError extends Error {
  readonly timeoutMs: number
  readonly label?: string

  constructor(timeoutMs: number, label?: string) {
    super(label ? `${label} timed out after ${timeoutMs}ms` : `Operation timed out after ${timeoutMs}ms`)
    this.name = 'HardTimeoutError'
    this.timeoutMs = timeoutMs
    this.label = label
  }
}

export async function runWithHardTimeout<T>(
  work: () => Promise<T>,
  opts: {
    timeoutMs: number
    label?: string
    onTimeout?: () => void
  },
): Promise<T> {
  const { timeoutMs, label, onTimeout } = opts
  let timer: ReturnType<typeof setTimeout> | null = null

  try {
    return await Promise.race([
      work(),
      new Promise<T>((_, reject) => {
        timer = setTimeout(() => {
          try { onTimeout?.() } catch {}
          reject(new HardTimeoutError(timeoutMs, label))
        }, timeoutMs)
      }),
    ])
  } finally {
    if (timer) clearTimeout(timer)
  }
}
